module.exports = function(app) {
	'use strict';
	app.service('provider', ['services', '$q', 'sessionData', '$filter', '$state', 'employerUtility','storage',
		function(services, $q, sessionData, $filter, $state, employerUtility, storage) {

			this.data = null;
			this.isLoading = false;
			this.failed = false;
			this.succeeded = false;
			var hasDependents = 0;

			this.load = function(employee, groupNumber) {
				var coverage = employee.data.subscriber.memberCoverages.filter(function(c) { return c.groupNumber === groupNumber; })[0];
				if (($state.is("assistEmployees.changePcp")) && (employee.data.dependents.length > 0)) {
					var ds = employee.data.dependents;
					for (var i = 0; i < ds.length; i++) {
						var lob = employerUtility.getLobStuffFromDependent(ds[i], groupNumber);
						var end = lob.coverageEndDate;
						if (!end || Date.parse(end) > Date.now()) {
							hasDependents += 1;
						}
					}
				}
				// hasDependents = employee.data.dependents.length;
                var theUbk = sessionData.employerInfo.brandName;
             var IsIBC = ((theUbk == '6009') || (theUbk == 6008))? true : false;
		
				var queryParams = {
					agreementNumber: (employee.data.agreementNumber + '0').slice(0, 10),
					contractHolderId: employee.data.subscriber.coveredIndividualId,
					clientId: sessionData.employerInfo.planAdministrator.clientId,
					clientName: sessionData.employerInfo.planAdministrator.company.substring(0, 35), //breaks if the length is over 35 characters.
					contractId: groupNumber,
					internalContractId: coverage.internalContractId,
					productIndicator: '' // this will soon be removed
				};
				var reasonCodeParams = {
					asOfDate: $filter('date')(new Date(), 'yyyy-MM-dd'),
					groupNumber: groupNumber,
					type: 'PCP'
				};

				var request;
				if (hasDependents) {
					request = $q.all({
						subscriber: services.rbsmbl.subscriberPCP().fetch(queryParams),
						dependents: services.rbsmbl.dependentsPCP().fetch(queryParams),
						reasonCodes: IsIBC ?  services.eprsvc.reasonCodesEprsvc().fetch() :services.rbsmbl.reasonCodes().fetch(reasonCodeParams)
					});
				}
				else {
					request = $q.all({
						subscriber: services.rbsmbl.subscriberPCP().fetch(queryParams),
						reasonCodes: IsIBC ?  services.eprsvc.reasonCodesEprsvc().fetch() :services.rbsmbl.reasonCodes().fetch(reasonCodeParams)
					});
				}
				this.isLoading = true;
				this.failed = false;
				this.succeeded = false;

				return request.then(

					function(response) {
						this.isLoading = false;
						this.failed = false;
						this.succeeded = true;
						this.data = {};
						if (
							response &&
							response.subscriber &&
							response.subscriber.data &&
							response.subscriber.data.payload
						) {
							storage.set('pcpNum',response.subscriber.data.payload.pcpNbr);

							if (response.subscriber.data.payload.insuranceLineCde !== 'HMO' && response.subscriber.data.payload.insuranceLineCde !== 'POS' && IsIBC===false && response.subscriber.data.payload.insuranceLineCde === 'PPO') {
								this.data = null;
								return this;
							}
						}
						if ( hasDependents && response && response.dependents && response.dependents.data ) {
							var ds = angular.copy(response.dependents.data.payload);
							// the service returns dependent objects that are mini-duplicates of other objects, so we gotta remove those
							// Object.keys(item).length == 19 Valid dependent objects have 19 properties
							for (var i = 0, length = ds.length; i < length; ++i) {
								var props = Object.keys(ds[i]).length;
								if (props !== 19) {
									ds.splice(length, 1);
								}
							}
							ds = ds.filter(function(d) {
								return Boolean(
									d.dob10Char != undefined &&
									(d.insuranceLineCde === 'HMO' ||
									d.insuranceLineCde === 'POS')
								);
							});
							this.data.dependents = this.normalizeIncomingDates(ds);
						}
						if (response && response.subscriber && response.subscriber.data && response.reasonCodes && response.reasonCodes.data) {
							this.data.subscriber = this.normalizeIncomingDates( [angular.copy(response.subscriber.data.payload)] )[0];
							this.data.reasonCodes = angular.copy(response.reasonCodes.data.payload.pcpReasonCode);
						}
						else {
							return new Error('PCP returned an unexpectedly formatted response: ' + JSON.stringify(response));
						}
						return this;
					}.bind(this),
					function() {
						this.isLoading = false;
						this.failed = true;
						this.succeeded = false;
						return this;
					}.bind(this)
				);
			}.bind(this);

			this.normalizeIncomingDates = function(providers) {
				var normalize = $filter('dateInput');

				providers.forEach(function(p) {
					p.contractCovEffDte = normalize(p.contractCovEffDte);
					p.dob10Char = normalize(p.dob10Char);
					p.pcpEffectiveDate = normalize(p.pcpEffectiveDate);
				});

				return providers;
			};

			this.normalizeOutgoingDates = function(providers) {
				var normalize = function(date) {
					return $filter('date')(date, 'MM/dd/yyyy');
				};

				providers.forEach(function(p) {
					p.contractCovEffDte = normalize(p.contractCovEffDte);
					p.dob10Char = normalize(p.dob10Char);
					p.pcpEffectiveDate = normalize(p.pcpEffectiveDate);
				});

				return providers;
			};

		}]);
};
